import React from "react";
import { connect } from "react-redux";
import Table from "react-bootstrap/Table";

const QueueStats = props => {
  const tableBody = props.queue_statistics.map((queue, idx) => {
    const abandonedPercentage =
      queue.total_calls === 0
        ? 0
        : Math.round((queue.abandoned / queue.total_calls) * 10000) / 100;

    return (
      <tr key={queue.system_name}>
        <td>{idx + 1}</td>
        <td>{queue.queue_name}</td>
        <td>{queue.agents_available}</td>
        <td>{queue.total_calls}</td>
        <td>{queue.calls_talking}</td>
        <td>{queue.calls_in_queue}</td>
        <td>{queue.abandoned}</td>
        <td>{abandonedPercentage}</td>
      </tr>
    );
  });

  return (
    <Table striped bordered hover variant="dark">
      <thead>
        <tr>
          <th>#</th>
          <th>Queue Name</th>
          <th>Agents Available</th>
          <th>Calls Answered</th>
          <th>Calls Talking</th>
          <th>Calls in Queue</th>
          <th>Abandoned Calls</th>
          <th>Percentage Abandoned (%)</th>
        </tr>
      </thead>
      <tbody>{tableBody}</tbody>
    </Table>
  );
};

const mapStateToProps = state => {
  return {
    queue_statistics: state.rmqReducer.queue_stats.queue_statistics,
  };
};
export default connect(mapStateToProps, {})(QueueStats);
